import { isErrorWithErrors } from '@/services/helpers';

type LegalEntityField = 'legalEntityName' | 'legalEntityFein';

export interface LicenseSaveErrors {
  fieldErrors: Partial<Record<LegalEntityField, string>>;
  general: string[];
}

export const GENERIC_LICENSE_SAVE_ERROR = 'Failed to save license. Please try again.';

// The message names the field that is MISSING, which is the one the user must fill in.
const LEGAL_ENTITY_PAIR_ERROR = /^Legal entity (FEIN|name) is required/i;

export function mapLicenseSaveErrors(error: unknown): LicenseSaveErrors {
  const result: LicenseSaveErrors = { fieldErrors: {}, general: [] };

  if (!isErrorWithErrors(error) || !Array.isArray(error.data.errors)) {
    result.general.push(GENERIC_LICENSE_SAVE_ERROR);
    return result;
  }

  for (const message of error.data.errors) {
    const match = LEGAL_ENTITY_PAIR_ERROR.exec(message);
    if (match) {
      const field: LegalEntityField = match[1].toLowerCase() === 'fein' ? 'legalEntityFein' : 'legalEntityName';
      result.fieldErrors[field] = message;
    } else {
      result.general.push(message);
    }
  }

  if (result.general.length === 0 && Object.keys(result.fieldErrors).length === 0) {
    result.general.push(GENERIC_LICENSE_SAVE_ERROR);
  }
  return result;
}
